export const CREATE_EMPLOYEE_DEPENDENT_DETAIL =
  "CREATE_EMPLOYEE_DEPENDENT_DETAIL";
export const FETCH_EMPLOYEE_DEPENDENT_DETAIL =
  "FETCH_EMPLOYEE_DEPENDENT_DETAIL";
export const FETCH_EMPLOYEE_DEPENDENT_DETAILS =
  "FETCH_EMPLOYEE_DEPENDENT_DETAILS";
export const EDIT_EMPLOYEE_DEPENDENT_DETAIL = "EDIT_EMPLOYEE_DEPENDENT_DETAIL";
export const DELETE_EMPLOYEE_DEPENDENT_DETAIL =
  "DELETE_EMPLOYEE_DEPENDENT_DETAIL";
